const prefix = 'profile';

const pageWrapper = `${prefix}__page-wrapper`;
const pageContainer = `${prefix}__container`;
const pageContainerCard = `${prefix}__container__card`;

const bannerBox = `${prefix}__banner`;
const headerBox = `${prefix}__header-box`;
const aboutBox = `${prefix}__about-box`;
const contactDetailsBox = `${prefix}__contact-details-box`;
const contactFormBox = `${prefix}__contact-form-box`;
const linksBox = `${prefix}__links-box`;
const filesBox = `${prefix}__files-box`;
const teamDirectoryBox = `${prefix}__team-directory-box`;

export const customCssClasses = {
  globalElements: {
    label: 'Global Elements',
    pageWrapper: { label: 'Page Wrapper', className: `${pageWrapper}` },
    pageContainer: { label: 'Page Container', className: `${pageContainer}` },
    pageContainerCard: { label: 'Page Container Card', className: `${pageContainerCard}` },
  },
  bannerBox: {
    label: 'Banner',
    container: { label: 'Container', className: `${bannerBox}` },
    image: { label: 'Image', className: `${bannerBox}__image` },
  },
  headerBox: {
    label: 'Header Box',
    container: { label: 'Container', className: `${headerBox}` },
    profilePictureContainer: {
      label: 'Profile Picture Container',
      className: `${headerBox}__profile-picture`,
    },
    profilePictureImage: {
      label: 'Profile Picture Image',
      className: `${headerBox}__profile-picture__image`,
    },

    logoContainer: { label: 'Logo Container', className: `${headerBox}__logo` },
    logoImage: { label: 'Logo Image', className: `${headerBox}__logo__image` },

    salutation: { label: 'Salutation', className: `${headerBox}__salutation` },
    academicDegree: { label: 'Academic Degree', className: `${headerBox}__academic-degree` },
    academicDegree2: { label: 'Academic Degree 2', className: `${headerBox}__academic-degree-2` },
    fullName: { label: 'Full Name', className: `${headerBox}__full-name` },
    position: { label: 'Position', className: `${headerBox}__position` },
    role: { label: 'Role', className: `${headerBox}__role` },
    division: { label: 'Division', className: `${headerBox}__division` },
    company: { label: 'Company', className: `${headerBox}__company` },

    saveContactButton: {
      label: 'Save Contact Button',
      className: `${headerBox}__save-contact-button`,
    },
  },

  aboutBox: {
    label: 'About Box',
    container: { label: 'Container', className: `${aboutBox}` },
    title: { label: 'Box Title', className: `${aboutBox}__title` },
    text: { label: 'Bio Text', className: `${aboutBox}__text` },
  },
  contactFormBox: {
    label: 'Contact Form Box',
    container: { label: 'Container', className: `${contactFormBox}` },
    title: { label: 'Box Title', className: `${contactFormBox}__title` },
    form: { label: 'Contact Form', className: `${contactFormBox}__form` },
    input: { label: 'Contact Form Input', className: `${contactFormBox}__input` },
    customField: { label: 'Custom Field Container', className: `${contactFormBox}__custom-field` },
    consent: { label: 'Consent Box', className: `${contactFormBox}__consent` },
    consentCheckbox: {
      label: 'Consent Checkbox',
      className: `${contactFormBox}__consent__checkbox`,
    },
    consentCheckboxLabel: {
      label: 'Consent Checkbox Label',
      className: `${contactFormBox}__consent__checkbox-label`,
    },
  },
  contactDetailsBox: {
    label: 'Contact Details Box',
    container: { label: 'Container', className: `${contactDetailsBox}` },
    title: { label: 'Box Title', className: `${contactDetailsBox}__title` },
    contactItem: { label: 'Contact Info Row', className: `${contactFormBox}__contact-item` },
    /* Generic contact item row */
    contactItemLabel: {
      label: 'Contact Info Row Label',
      className: `${contactFormBox}__contact-item__label`,
    },
    contactItemIcon: {
      label: 'Contact Info Row Icon',
      className: `${contactFormBox}__contact-item__icon`,
    },
    /* Phone contact item row */
    contactItemPhone: {
      label: 'Contact Info Phone Row',
      className: `${contactFormBox}__contact-item--phone`,
    },
    contactItemPhoneLabel: {
      label: 'Contact Info Phone Row Label',
      className: `${contactFormBox}__contact-item--phone__label`,
    },
    contactItemPhoneIcon: {
      label: 'Contact Info Phone Row Icon',
      className: `${contactFormBox}__contact-item--phone__icon`,
    },
    /* Email contact item row */
    contactItemEmail: {
      label: 'Contact Info Email Row',
      className: `${contactFormBox}__contact-item--email`,
    },
    contactItemEmailLabel: {
      label: 'Contact Info Email Row Label',
      className: `${contactFormBox}__contact-item--email__label`,
    },
    contactItemEmailIcon: {
      label: 'Contact Info Email Row Icon',
      className: `${contactFormBox}__contact-item--email__icon`,
    },
    /* Address contact item row */
    contactItemAddress: {
      label: 'Contact Info Address Row',
      className: `${contactFormBox}__contact-item--address`,
    },
    contactItemAddressLabel: {
      label: 'Contact Info Address Row Label',
      className: `${contactFormBox}__contact-item--address__label`,
    },
    contactItemAddressIcon: {
      label: 'Contact Info Address Row Icon',
      className: `${contactFormBox}__contact-item--address__icon`,
    },
    /* Website contact item row */
    contactItemWebsite: {
      label: 'Contact Info Website Row',
      className: `${contactFormBox}__contact-item--website`,
    },
    contactItemWebsiteLabel: {
      label: 'Contact Info Website Row Label',
      className: `${contactFormBox}__contact-item--website__label`,
    },
    contactItemWebsiteIcon: {
      label: 'Contact Info Website Row Icon',
      className: `${contactFormBox}__contact-item--website__icon`,
    },
  },
  linksBox: {
    label: 'Links Box',
    container: { label: 'Container', className: `${linksBox}` },
    title: { label: 'Box Title', className: `${linksBox}__title` },
    links: { label: 'Links', className: `${linksBox}__links` },
    linkItem: { label: 'Link Item', className: `${linksBox}__link__item` },
    linkItemIcon: { label: 'Link Item Icon', className: `${linksBox}__link__item__icon` },
    linkItemText: { label: 'Link Item Text', className: `${linksBox}__link__item__text` },
  },
  filesBox: {
    label: 'Files Box',
    container: { label: 'Container', className: `${filesBox}` },
    title: { label: 'Box Title', className: `${filesBox}__title` },
    files: { label: 'Files', className: `${filesBox}__files` },
    fileItem: { label: 'File Item', className: `${filesBox}__file__item` },
    fileItemIcon: { label: 'File Item Icon', className: `${filesBox}__file__item__icon` },
    fileItemText: { label: 'File Item Text', className: `${filesBox}__file__item__text` },
    videoItem: { label: 'Video Item', className: `${filesBox}__video__item` },
    videoItemText: { label: 'Video Item Text', className: `${filesBox}__video__item__text` },
  },
  teamDirectoryBox: {
    label: 'Team Directory Box',
    container: { label: 'Container', className: `${teamDirectoryBox}` },
    title: { label: 'Box Title', className: `${teamDirectoryBox}__title` },
    teamMembers: { label: 'Team Members', className: `${teamDirectoryBox}__team-members` },
    teamMember: { label: 'Team Member', className: `${teamDirectoryBox}__team-members__member` },
    teamMemberImage: {
      label: 'Team Member Image',
      className: `${teamDirectoryBox}__team-members__member__image`,
    },
    teamMemberName: {
      label: 'Team Member Name',
      className: `${teamDirectoryBox}__team-members__member__name`,
    },
    teamMemberPosition: {
      label: 'Team Member Position',
      className: `${teamDirectoryBox}__team-members__member__position`,
    },
  },
};

export const customCssClassesArray = Object.values(customCssClasses).map(({ label, ...rest }) => ({
  label,
  items: Object.values(rest),
}));
